<template>
  <div>
    <div class="d-flex justify-content-between">
        <h4 class="mb-1 pl-2 font-weight-bold">Gift Information</h4>
        <span>Date: {{ details.created_at }}</span>
      </div>
      {{ details }}
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    details: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {
        getAppliedOnData (data)  {
      return [...data.tickets.map(ticket => ticket.name),...data.promotions.map(promotion => promotion.name)]
    },
        getRemainingDays(dateString) {
      const today = new Date();
      const targetDate = new Date(dateString);

      today.setHours(0, 0, 0, 0);
      targetDate.setHours(0, 0, 0, 0);

      const diffTime = targetDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
  },
  watch: {},
  created () {
  }
}
</script>

<style lang="scss" scoped>
</style>
